import React from 'react';
import Index from "./Components/Index";
import './App.css';

function App() {
    return <Index style={{height: "100%"}}/>;
}

export default App;
